export const visuallyHidden = "visually-hidden";
export const quietLink = "quiet-link";

export function classes(...names: readonly (string | false | undefined)[]): string {
  return names.filter((name) => typeof name === "string" && name !== "").join(" ");
}
